import React, { useEffect, useRef } from 'react'
import * as E from '../../elementor'
import SlideExperiment from './slide-experiment'
import parse from 'html-react-parser'
import { register } from 'swiper/element/bundle'
import SwiperNext from '../../images/swiper-right.svg'
import SwiperPrev from '../../images/swiper-left.svg'

import 'swiper/scss'
import 'swiper/scss/navigation'
register()

const DirectoryExperiment = ({ section }) => {
  const swiperRef = useRef(null)
  const nextRef = useRef(null)
  const prevRef = useRef(null)

  const { slides, heading, textEditor, button, basicGallery } = E.collect(section)

  const title = heading[0]?.title || ''
  const upperSubTitle = textEditor[0]?.text() || ''
  const slideGroup = slides[0]?.slides


  useEffect(() => {
    const swiperContainer = swiperRef.current
    const params = {
      slidesPerView: 'auto',
      spaceBetween: 10,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextRef.current,
        prevEl: prevRef.current
      },
      scrollbar: {
       // el: '.swiper-scrollbar',
        draggable: false, // Disable manual scrolling of the scrollbar
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          centeredSlides: true,
        },
        500: {
          slidesPerView: 2.5,
        },
        545: {
          slidesPerView: 2.7,
        },
        615: {
          slidesPerView: 2.9,
        },
        765: {
          slidesPerView: 3,
        },
        840: {
          slidesPerView: 3.5,
        },
        1025: {
          slidesPerView: 4,
        },
        1210: {
          slidesPerView: 4.5,
        },
         1400: {
          slidesPerView: 5,
        }
      },
      injectStyles: [
        `
          .swiper-container {
            padding-left: 1rem;
          }
          .swiper-button-disabled {
            display: none;
          }
          .swiper-wrapper {
            margin-bottom: 3.75rem;
          }
          .swiper-scrollbar {
            background: #f5f5f5;
            display: none;
          }
          .swiper-scrollbar.swiper-scrollbar-horizontal {
            height: 2px;
            width: calc(100vw - 10rem);
            left: 16rem;
          }
          .swiper-scrollbar-drag {
            background: #262626;
          }
          @media (max-width: 640px) {
            .swiper-scrollbar {
              display: block;
              position: absolute:
            }
            .swiper-slide {
              flex: 0 0 100%;
            }
          }
          @media (max-width: 499px) {
            .swiper-scrollbar {
              display: block;
              position: absolute:
              width: calc(100vw - 180px);
            }
            .swiper-scrollbar.swiper-scrollbar-horizontal {
              left: 0;
            }
          }
        `
      ]
    }

    if (swiperContainer !== undefined && swiperContainer !== null) {
      Object.assign(swiperContainer, params);
      (swiperContainer as any).initialize()
    }
  }, [])

  return (
    <section>
      <div className='directory-wrapper-experiment'>
        <div className='directory-title-wrapper'>
          <div className='directory-title'>
            <p>{parse(upperSubTitle)}</p>
            <h2>{parse(title)}</h2>
          </div>
        </div>
        <div className='directory-slides-wrapper'>
          <button ref={prevRef} className='swipe-prev' aria-label='Previous slide' style={{ backgroundImage: `url(${SwiperPrev})`}} />
          <swiper-container ref={swiperRef} navigation='true' init='false'>
            {slideGroup?.map((slide, index) => {
              return <SlideExperiment slide={slide} img={basicGallery[0]?.images[index]} key={index} />
            })}
          </swiper-container>
          <button ref={nextRef} className='swipe-next' aria-label='Next slide' style={{ backgroundImage: `url(${SwiperNext})`}} />
        </div>
      </div>
    </section>
  )
}

export default DirectoryExperiment
